import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const TABS = [
  { link: "/dashboard", label: "Home", icon: "home" },
  { link: "/forms", label: "Forms", icon: "description" },
  { link: "/queries", label: "Inbox", icon: "inbox" },
  { link: "/notes", label: "Notes", icon: "sticky_note_2" },
  { link: "/myprofile", label: "More", icon: "apps" },
];

/**
 * Native-style bottom tab bar for authenticated mobile.
 */
const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (link) => {
    if (link === "/forms") {
      return location.pathname === "/forms" || location.pathname.startsWith("/forms/");
    }
    if (link === "/myprofile") {
      return ["/myprofile", "/support", "/plans"].includes(location.pathname);
    }
    return location.pathname === link;
  };

  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 z-[900] bg-[#0B1C2D]/95 backdrop-blur-xl border-t border-white/10 pb-[env(safe-area-inset-bottom,0px)]"
      role="navigation"
      aria-label="Primary"
    >
      <ul className="grid grid-cols-5 h-[4.25rem]">
        {TABS.map((tab) => {
          const active = isActive(tab.link);
          return (
            <li key={tab.link} className="min-w-0">
              <button
                type="button"
                onClick={() => navigate(tab.link)}
                className={`w-full h-full flex flex-col items-center justify-center gap-0.5 transition-colors active:scale-95 ${
                  active ? "text-[#E63946]" : "text-white/55"
                }`}
                aria-current={active ? "page" : undefined}
              >
                <span
                  className={`material-symbols-outlined text-[22px] ${
                    active ? "filled" : ""
                  }`}
                  style={
                    active
                      ? { fontVariationSettings: "'FILL' 1" }
                      : undefined
                  }
                >
                  {tab.icon}
                </span>
                <span className="text-[10px] font-bold tracking-wide truncate px-0.5">
                  {tab.label}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default MobileBottomNav;
